import type {OmnichannelChatContextValue} from '@/modules/common/context/OmnichannelChat/models';

import {useMemo, useState} from 'react';

import {OmnichannelChatContext} from '@/modules/common/context/OmnichannelChat/OmnichannelChatContext';

type Props = React.PropsWithChildren;

export const OmnichannelChatProvider: React.FunctionComponent<Props> = ({
  children,
}) => {
  const [omnichannelChatWidgetApi, setOmnichannelChatWidgetApi] =
    useState<OmnichannelChatContextValue[0]>(null);

  const omnichannelChat = useMemo<OmnichannelChatContextValue>(
    () => [omnichannelChatWidgetApi, setOmnichannelChatWidgetApi],
    [omnichannelChatWidgetApi]
  );

  return (
    <OmnichannelChatContext.Provider value={omnichannelChat}>
      {children}
    </OmnichannelChatContext.Provider>
  );
};
